/*
 * Public API Surface of ngx-slimscroll
 */

export * from './lib/slimscroll-event.class';
export * from './lib/slimscroll-options.class';
export * from './lib/slimscroll-state.class';
export * from './lib/slimscroll.directive';
export * from './lib/slimscroll.module';
